import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { CompanyReportItemWire, RootCode } from './types';
import { BlobResponse, RemoteData, Resource } from 'app/infrastructure/remote-data';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadRootUserGroups: async (): Promise<RootCode> => {
    const response = await new RemoteAdminData(endpoints.userGroupOptions)
      .resource<ApiResponse<RootCode>>()
      .filter({ levels: 1 })
      .all();

    return response.data;
  },

  loadCompanyReport: async (id: number): Promise<CompanyReportItemWire> => {
    const response = await new RemoteAdminData(endpoints.companyReportItem)
      .resource<ApiResponse<CompanyReportItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteCompanyReport: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.companyReportItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  createCompanyReport: async (companyReport: CompanyReportItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.companyReportItem)
      .resource<ApiResponse<number>>()
      .create(companyReport, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  saveCompanyReport: async (id: number, companyReport: CompanyReportItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.companyReportItem)
      .resource<void>()
      .withId(id)
      .save(companyReport);

    return id;
  },

  loadTextDescription: async (textId: number, textSet: number): Promise<any> => {
    const response = await new RemoteAdminData(endpoints.text(textId, textSet))
      .resource<ApiResponse<CompanyReportItemWire>>()
      .single();

    return response.data;
  },

  downloadTemplate: async (reportId: number | string): Promise<Resource<BlobResponse>> => {
    return await new RemoteData(endpoints.specialReportTemplate(reportId))
      .resource<BlobResponse>();
  }
};
